import React from 'react';
import { Text } from '@wegroup/design-system';

// Components
import AccidentsInput from './AccidentsInput';

// Types
import { Accident } from '../../../../../../../types/ProductFactory';
import { Change } from '../../../../../../../types/Form';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
interface Props {
  question: FlowsQuestion;
}

const AccidentsInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const {
    field: { value, onBlur },
    error,
  } = useFlowInputComponent({ question });

  const accidents = (value as Accident[] | undefined) || [];

  const handleChange = async (e: Change) => {
    await onBlur(e);
  };

  return (
    <>
      {error && (
        <Text mb="4" color="danger.main">
          {error?.message}
        </Text>
      )}
      <AccidentsInput
        name={question.id}
        accidents={accidents}
        handleChange={handleChange}
      />
    </>
  );
};
export default AccidentsInputComponent;
